class WorkshopRejectedVisit {
  constructor(firstProposition, secondProposition, rejectionReason) {
    this.firstProposition = firstProposition;
    this.secondProposition = secondProposition;
    this.rejectionReason = rejectionReason;
  }
}

export default WorkshopRejectedVisit;
